import React, {Component} from 'react'
import Link from "next/link"
import moment from "moment";
import {Trans} from "@lingui/react/macro"

export default class CardText extends Component{

    render(){
        const {org}=this.props.context
        const item=this.props.item
        const link=this.props.link

        var finalLink=link
        if(item.link){
            finalLink=item.link
        }


        return (
            <div className="post post-text-wrap">
                {Array.isArray(item.thematiques) && item.thematiques.length>0 &&(
                    <div className="blog-thumb-text">
                        <span>{item.thematiques[0]}</span>
                    </div>
                )}
                <ul className="entry-meta">
                    <li><Link href={finalLink}><span style={{textTransform:"uppercase",cursor:"pointer"}}> {org.contact.prenom} {org.contact.nom}</span></Link></li>
                    <li><Link href={finalLink}>{moment(item.datetime).format("DD MMM YYYY")}</Link></li>
                </ul>
                <h3><Link href={finalLink}>{item.title}</Link></h3>
                <p>{item.description}</p>
                <div className="entry-bottom">
                    <Link href={finalLink}>
                        <span className="read-more"><Trans>Voir Plus...</Trans></span>
                    </Link>
                </div>
            </div>
        )
    }
}
